import Statements from "./pages/dashboard/statements/Statements";
import Home from "./pages/dashboard/Home";
import { Routes, Route, useLocation } from "react-router-dom";
import { getCookie } from "cookies-next";
import SignIn from "./pages/auth/SignIn";
import ClientProfile from "./pages/dashboard/statements/ClientProfile";
import FAQs from "./pages/dashboard/FAQs";
import { logout } from "./redux/actions/auth";
import { authanticatedUser } from "./utils/helper";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { jwtDecode } from "jwt-decode";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ResetPassword from "./pages/auth/ResetPassword";

function App() {
  const dispatch = useDispatch();
  const authUser = getCookie("loggedInUser");
  const location = useLocation();

  useEffect(() => {
    if (authanticatedUser) {
      // Decode the token to get the expiration time
      const decoded = jwtDecode(authanticatedUser.token);
      // Get the current time
      const currentTime = new Date().getTime() / 1000;
      // // Check if the token has expired
      if (decoded.exp < currentTime) {
        // Clear the user data from local storage
        dispatch(logout());
      } else {
        if (location.pathname === "/") {
          window.location = "/dashboard";
        }
      }
    }
  }, [dispatch, location.pathname]);

  return (
    <div className="App">
      {!authanticatedUser ? (
        <Routes>
          <Route path="/" element={<SignIn />} />
          <Route path="/resetpassword" element={<ResetPassword />} />
          <Route path="*" element={<SignIn />} />
        </Routes>
      ) : (
        <Routes>
          <Route exact path="/dashboard" index element={<Home />} /> 
          <Route path="/statements" element={<Statements />} />
          <Route path="/profile" element={<ClientProfile />} />
          <Route path="/faqs" element={<FAQs />} />

          <Route path="*" element={<Home />} />
        </Routes>
      )}
      <ToastContainer />
    </div>
  );
}

export default App;
